export default "__VITE_ASSET__112cf6e8__"